import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: 'Як зробити замовлення?',
  answer: "Оскільки ми надаємо персоналізований бутиковий сервіс, усі замовлення оформлюються через прямий контакт. Просто перегляньте наш каталог, оберіть бажані речі та натисніть 'Зв'язатися' або 'Дізнатися / Замовити'. Ви можете зв'язатися з нами через Telegram, Instagram або телефоном. Наш менеджер підтвердить наявність, допоможе з розміром та організує оплату і доставку."
}, {
  question: 'Як дізнатися свій розмір?',
  answer: "Ми розуміємо, що ідеальна посадка має вирішальне значення. Коли ви зв'яжетеся з нами для замовлення, наш менеджер запитає ваші точні параметри (обхват грудей, талії, стегон) і порекомендує найкращий розмір для конкретної речі. Ми також можемо зробити незначні коригування за запитом."
}, {
  question: 'Які способи оплати ви приймаєте?',
  answer: 'Ми приймаємо прямі банківські перекази на наш український рахунок (ПриватБанк / Monobank). Повна оплата необхідна перед відправкою.'
}, {
  question: 'Чи приймаєте ви повернення або обмін?',
  answer: 'Так, ми приймаємо повернення та обмін протягом 14 днів після отримання вашого замовлення, за умови, що річ не була у використанні, не пралася та має всі оригінальні бірки. Речі, пошиті за індивідуальними мірками, поверненню не підлягають.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-white" data-id="element-155">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-156">
        <div className="text-center mb-16" data-id="element-157">
          <h2 className="text-4xl md:text-5xl font-serif text-brand-dark mb-4" data-id="element-158">
            Часті запитання
          </h2>
        </div>

        <div className="space-y-4" data-id="element-159">
          {faqs.map((faq, index) => <div key={index} className="border border-brand-beige rounded-2xl overflow-hidden" data-id="element-160">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between bg-brand-cream/50 hover:bg-brand-cream transition-colors text-left" data-id="element-161">
                <span className="font-medium text-brand-dark pr-4" data-id="element-162">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-brown transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-163" />
              </button>

              <AnimatePresence data-id="element-164">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-165">
                    <div className="px-6 py-5 text-brand-dark/70 bg-white border-t border-brand-beige" data-id="element-166">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}